import { mapState } from 'vuex'
import TextEditor from '@/components/common/texteditor/TextEditor.vue'
import LocalePicker from '@/components/common/localepicker/LocalePicker.vue'

export default {
  name: 'MultilangInput',
  props: {
    value: [String, Object],
    disabled: Boolean,
    type: String,
    rowcount: {
      type: Number,
      default: 4
    },
    noresize: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      content: (this.value === null) ? [] : this.value,
      selectedLocale: null
    };
  },
  components: {
    TextEditor,
    LocalePicker
  },
  computed: {
    ...mapState(['config']),
    inputtype () {
      if (this.type) {
        return this.type;
      }
      return 'input';
    }
  },
  methods: {
    localechanged (el) {
      if (this.$refs.textEditor) {
        this.$refs.textEditor.updateContent(this.content[el] ? this.content[el] : '');
      }
    },
    updateValue () {
      this.$emit('input', this.content)
    }
  }
}
